import dispatcher from "../dispatcher"

const utils = require("../helpers/utils")
const api = require("../api")

export function loadSection1Data(shortcode) {
    return api.loadSection1Data(shortcode).then(function(result) {
        return result.data
    })
}

export function patchI9(i9Id, i9) {
    return api.patchI9(i9Id, i9).then(function(result) {
        dispatcher.dispatch({ type: "RECEIVE_USER_I9", object: result.data })
        return result.data
    })
}

export function patchSection1Data(i9Id, i9) {
    return api.patchSection1Data(i9Id, i9).then(function(result) {
        return result.data
    })
}

export function loadI9(i9Id) {
    return api.getI9(i9Id).then(function(result) {
        dispatcher.dispatch({ type: "RECEIVE_USER_I9", object: result.data })
        return result.data
    })
}

export function loadI9Pdf(i9Id) {
    return api.getI9Pdf(i9Id).then(function(result) {
        dispatcher.dispatch({
            type: "RECEIVE_USER_I9_PDF",
            object: result.data
        })
        return result.data
    })
}

export function loadI9ByUserId(userId) {
    return api.getUserI9(userId).then(function(result) {
        dispatcher.dispatch({ type: "RECEIVE_USER_I9", object: result.data })
        return result.data
    })
}

export function addGovernmentDoc(i9Id, doc) {
    return api.postGovernmentDoc(i9Id, doc).then(function(result) {
        dispatcher.dispatch({ type: "RECEIVE_USER_I9", object: result.data })
        return result.data
    })
}
